module.exports = __webpack_public_path__ + "img/bg.731482ac.png";